<template>
  <div id="vue-admin-beautiful">
    <a-config-provider :locale="locale" :componentSize="'middle'">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import 'dayjs/locale/zh-cn'
  import { getEnum } from '@/api/common'
  import { getModal } from '@/api/system_manage/modal'
  import { getData as getGate } from '@/api/equipment_management/gate'
  import { getDept } from '@/api/system_manage/dept'
  import { getNoticeTypeEnum, getNoticeStatusEnum } from '@/api/notice/notice'
  import { getUser } from '@/api/system_manage/userManage'
  import { capitalizeFirstLetter, resListToEnum } from '@/utils/format'
  import { allEnum } from '@/utils/common'
  import store from './store'
  import dayjs from 'dayjs'
  import { getAccessToken } from '@/utils/auth'

  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
      }
    },
    mounted() {
      dayjs.locale('zh-cn')
      this.getAllEnum()
    },
    methods: {
      //获取所有映射表
      async getAllEnum () {
        if (!getAccessToken()) return
        const typeEnum = await getNoticeTypeEnum()
        store.dispatch('common/setNoticeType', typeEnum.data, { saveData: true })
        const statusEnum = await getNoticeStatusEnum()
        store.dispatch('common/setNoticeStatus', statusEnum.data, { saveData: true })

        for (let i in allEnum) {
          const item = allEnum[i]
          let name = item,
            value = item
          if (item.constructor === Object) {
            name = item.name
            value = item.value
          }
          getEnum({ name }).then((res) => {
            if (res.success) {
              const actionName = 'common/set' + capitalizeFirstLetter(value)
              store.dispatch(actionName, res.data)
            }
          })
        }

        getModal({
          size: Number.MAX_SAFE_INTEGER,
          pn: 1,
        }).then((res) => {
          store.dispatch(
            'common/setCarModel',
            resListToEnum(res.data.list, { toString: true })
          )
          store.dispatch(
            'common/setCarModelObj',
            resListToEnum(res.data.list, { saveData: true })
          )
        })

        getDept().then((res) => {
          store.dispatch(
            'common/setDept',
            resListToEnum(res.data, { idName: 'depart_id' })
          )
        })
        getGate({
          size: 999,
          pn: 1,
          state: -1,
          type: -1,
        }).then((res) => {
          store.dispatch('common/setGate', resListToEnum(res.data.list))
        })
        getUser({
          size: 999999,
          pn: 1,
        }).then((res) => {
          store.dispatch(
            'common/setUser',
            resListToEnum(res.data.list, {
              idName: 'user_id',
              valueName: 'user_name',
            })
          )
        })
      },
    },
  }
</script>
<style lang="less">
  @import '~@/vab/styles/vab.less';
  @import '~@/assets/common.less';
</style>
